import React, { useCallback, useEffect, useState } from 'react';
import { Tour } from 'antd';

import useGlobalTourCheck from 'src/hooks/useGlobalTourCheck';
import useHelpEvent from 'src/hooks/useHelpEvent';
import AssetUsageOverviewVideo from './AssetUsageOverviewVideo';
import { boardingTourMap } from 'src/utils/onBoardingVideos';
import { config } from 'src/utils/config';

type TourProps = {
  title: string;
  description: string;
  path: string;
  uniqueId: string;
  style?: React.CSSProperties;
};

const BoardingTourWrapper: React.FC<TourProps> = ({ title, description, path, uniqueId, style }) => {
  const [tourOpen, setTourOpen] = useState(false);

  const tourButtonProps = { style: { fontWeight: 600, fontSize: 12, ...style } };
  const steps: any = [
    {
      title: title,
      description: description,
      nextButtonProps: tourButtonProps,
      target: null,
      type: 'primary',
      placement: 'center',
      cover: boardingTourMap?.[uniqueId] ? (
        <AssetUsageOverviewVideo videoUrl={boardingTourMap?.[uniqueId]} />
      ) : null,
    },
  ];

  useGlobalTourCheck(() => setTourOpen(true),path);

  const handleMatch = useCallback(() => {
    setTourOpen(true);
  }, []);

  useHelpEvent(path, handleMatch);

  return <Tour open={tourOpen} onClose={() => setTourOpen(false)} steps={steps} gap={{ radius: 5 }} />;
};

export const BoardingTour: React.FC<TourProps> = (props) => {
  if (!config.showTour) {
  return null;
  }

  return <BoardingTourWrapper {...props} />;
};

